import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faXmark,
  faPhone,
  faEnvelope,
  faCalendarCheck,
  faMoon,
  faSun,
} from "@fortawesome/free-solid-svg-icons";
import "../Styles/Navbar.css";
import { Link, NavLink } from "react-router-dom";
import logo from "../Images/logo.jpg";
import { CONTACT, SOCIALS } from "../Scripts/siteData";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/apply", label: "Apply with Us" },
  { to: "/contact", label: "Contact" },
];

function Navbar() {
  const [nav, setNav] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [dark, setDark] = useState(
    () => document.documentElement.getAttribute("data-theme") === "dark"
  );

  const openNav = () => setNav(true);
  const closeNav = () => setNav(false);

  const toggleTheme = () => {
    const next = dark ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", next);
    try {
      localStorage.setItem("hr-theme", next);
    } catch (e) {
      /* ignore storage errors */
    }
    setDark(!dark);
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Top contact bar */}
      <div className={`topbar ${scrolled ? "topbar-hide" : ""}`}>
        <div className="topbar-inner hr-container">
          <div className="topbar-left">
            <a href={CONTACT.phoneHref} className="topbar-item">
              <FontAwesomeIcon icon={faPhone} /> {CONTACT.phone}
            </a>
            <a href={CONTACT.emailHref} className="topbar-item">
              <FontAwesomeIcon icon={faEnvelope} /> {CONTACT.email}
            </a>
          </div>
          <div className="topbar-socials">
            {SOCIALS.map((s) => (
              <a
                key={s.name}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.name}
              >
                <FontAwesomeIcon icon={s.icon} />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Main nav */}
      <header className={`navbar-section ${scrolled ? "navbar-scrolled" : ""}`}>
        <div className="navbar-inner hr-container">
          <Link to="/" className="navbar-brand" onClick={closeNav}>
            <img
              src={logo}
              alt="Harmony Rise Homecare"
              className="navbar-logo"
            />
            <span className="navbar-brand-text">
              Harmony Rise
              <small>Home Care</small>
            </span>
          </Link>

          <nav className="navbar-items">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `navbar-links ${isActive ? "navbar-link-active" : ""}`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
            title={dark ? "Light mode" : "Dark mode"}
          >
            <FontAwesomeIcon icon={dark ? faSun : faMoon} />
          </button>

          <Link
            to="/book-appointment"
            className="navbar-cta desktop-cta hr-btn hr-btn-primary"
          >
            <FontAwesomeIcon icon={faCalendarCheck} /> Book An Appointment
          </Link>

          <button
            className="mobile-nav"
            onClick={openNav}
            aria-label="Open menu"
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>
      </header>

      {/* Mobile drawer */}
      <div className={`mobile-navbar ${nav ? "open-nav" : ""}`}>
        <div className="mobile-navbar-head">
          <span className="navbar-brand-text">
            Harmony Rise
            <small>Home Care</small>
          </span>
          <button
            onClick={closeNav}
            className="mobile-navbar-close"
            aria-label="Close menu"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <ul className="mobile-navbar-links">
          {links.map((l) => (
            <li key={l.to}>
              <NavLink onClick={closeNav} to={l.to}>
                {l.label}
              </NavLink>
            </li>
          ))}
          <li>
            <Link to="/book-appointment" onClick={closeNav} className="mobile-cta">
              <FontAwesomeIcon icon={faCalendarCheck} /> Book An Appointment
            </Link>
          </li>
          <li>
            <a href="tel:2535230098" onClick={closeNav} className="mobile-call">
              <FontAwesomeIcon icon={faPhone} /> 253-523-0098
            </a>
          </li>
        </ul>
      </div>

      {nav && <div className="mobile-overlay" onClick={closeNav} />}
    </>
  );
}

export default Navbar;
